import React, { useRef, useState } from "react";
import "./address-bar.css";
import { Input, Button, MapDemoContext } from "..";

function AddressBar({ address }) {
  // let destinations = [];
  const address_form = useRef(null);

  const [isEditting, setIsEditting] = useState(false);
  const [onInputTimeOut, setOnInputTimeOut] = useState([]);

  const submitAddress = (
    e,
    updateAddress,
    destinations,
    updateDestinations,
    location,
    updateLocation,
    updateName,
    name,
    addressId,
    updateAddressId,
    time,
    setTime,
    setMessage
  ) => {
    setMessage({text: 'پیام‌های شما اینجا نمایش داده می‌شود.', type: 'default'})
    // if any destination was editting it would not be -1
    let isFormValid = address_form.current.checkValidity();
    e.preventDefault();

    if (isFormValid) {
      let updatedDestinationId = destinations.findIndex(
        i => i.id === addressId
      );
      if (updatedDestinationId === -1) {
        // new destination is being added

        if (
          addressId >= 0 &&
          (location || address) &&
          name.length &&
          time.length
        ) {
          destinations.push({
            id: addressId,
            address,
            location,
            name,
            time
          });
          updateAddressId();
        } else {
          // address details are not complete (mainly name)
          return;
        }
      } else {
        // editting item
        destinations[updatedDestinationId] = {
          id: addressId,
          address,
          location,
          name,
          time
        };
        updateAddressId(
          parseInt(
            document.querySelectorAll(".item-wrapper:last-child")[0].dataset.id
          ) + 1
        );
      }

      updateDestinations(destinations);
      updateAddress("");
      updateLocation({
        lat: "",
        lng: ""
      });
      updateName("");
      setTime("00:00:00");
    } else {
      // address_form.current.reportValidity();
    }
  };

  const deleteInputs = (
    address,
    updateAddress,
    updateLocation,
    markers,
    updateMarkers,
    updateName,
    setTime
  ) => {
    if (isEditting) return;
    else {
      if (address !== "") {
        markers.pop();
        updateMarkers(markers);
      }
      updateAddress("");
      updateLocation({
        lat: "",
        lng: ""
      });
      updateName("");
      setTime("00:00:00");
    }
  };

  const InvalidMsg = (textbox, requiredMessage, wrongMessage, setMessage) => {
    textbox.focus();
    textbox.parentNode.classList.add("error")
    if (textbox.value === "") {
      textbox.setCustomValidity(requiredMessage);
      setMessage({
        text: requiredMessage,
        type: 'validation'
      })
    } else if (
      textbox.validity.typeMismatch ||
      textbox.validity.patternMismatch
    ) {
      textbox.setCustomValidity(wrongMessage);
      setMessage({
        text: wrongMessage,
        type: 'validation'
      })
    } else {
      textbox.setCustomValidity("");
      setMessage({
        text: 'پیام‌های شما اینجا نمایش داده می‌شود.',
        type: 'default'
      })
      textbox.parentNode.classList.remove("error")
    }

    return true;
  };

  return (
    <MapDemoContext.Consumer>
      {({
        address,
        updateAddress,
        destinations,
        updateDestinations,
        location,
        updateLocation,
        markers,
        updateMarkers,
        apiKey,
        centerMarker,
        updateCenterMarker,
        centerCoordinate,
        updateCenterCoordinate,
        name,
        updateName,
        addressId,
        updateAddressId,
        inputMethod,
        demo,
        time,
        setTime,
        setMessage
      }) => {
        setIsEditting(false);

        if (
          [...document.querySelectorAll(".item-wrapper")].some(
            item => item.dataset.id === addressId.toString()
          )
        )
          setIsEditting(true);

        let style =
          inputMethod === "1" ? { display: "none" } : { display: "flex" };

        return (
          <div
            className="main-bar"
            data-id={addressId}
            data-input-method={inputMethod}
          >
            <form ref={address_form}>
              <div style={style} className="longitude">
                <label>طول جغرافیایی</label>
                <Input
                  primary
                  pattern="[+-]?\d+(\.\d+)?"
                  onInvalid={e => {
                    InvalidMsg(
                      e.target,
                      "لطفا طول جغرافیایی را وارد نمایید",
                      "فرمت وارد شده صحیح نیست.",
                      setMessage
                    );
                  }}
                  value={location.lng}
                  placeholder="طول جغرافیایی"
                  onInput={e => {
                    e.target.value = window.toEnglishDigits(e.target.value);
                    updateLocation({ lat: location.lat, lng: e.target.value });

                    if (location.lat !== "" &&
                      e.target.value <= 90 &&
                      e.target.value >= -90 &&
                      location.lat <= 90 &&
                      location.lat >= -90
                    ) {
                      if (onInputTimeOut !== undefined)
                        clearTimeout(onInputTimeOut);
                      setOnInputTimeOut(
                        setTimeout(
                          (lng => {
                            if(!isEditting) {
                              var tempCenterMarker = [];
                              tempCenterMarker.push(
                                <div
                                  key={Math.random()}
                                  className="marker-container"
                                  onDoubleClick={() =>
                                    this.setMarker(
                                      updateAddress,
                                      updateLocation,
                                      apiKey,
                                      updateMarkers,
                                      centerMarker,
                                      updateCenterMarker,
                                      updateName
                                    )
                                  }
                                ></div>
                              );
  
                              updateCenterMarker(tempCenterMarker);
                            }
                            if (isEditting) {
                              let _markers = markers;
                              _markers[addressId] = [lng,location.lat];
                              updateMarkers(_markers);
                            }

                            updateCenterCoordinate({
                              lat: location.lat,
                              lng: lng
                            });
                          }).bind(null, e.target.value),
                          500
                        )
                      );
                    }
                  }}
                />
              </div>
              <div style={style} className="latitude">
                <label>عرض جغرافیایی</label>
                <Input
                  primary
                  pattern="[+-]?\d+(\.\d+)?"
                  onInvalid={e => {
                    InvalidMsg(
                      e.target,
                      "لطفا عرض جغرافیایی را وارد نمایید",
                      "فرمت وارد شده صحیح نیست.",
                      setMessage
                    );
                  }}
                  value={location.lat}
                  placeholder="عرض جغرافیایی"
                  onInput={e => {
                    e.target.value = window.toEnglishDigits(e.target.value);
                    updateLocation({ lat: e.target.value, lng: location.lng });

                    if (location.lng !== "" &&
                      e.target.value <= 90 &&
                      e.target.value >= -90 &&
                      location.lng <= 90 &&
                      location.lng >= -90
                    ) {
                      if (onInputTimeOut !== undefined)
                        clearTimeout(onInputTimeOut);
                      setOnInputTimeOut(
                        setTimeout(
                          (lat => {
                            
                            if(!isEditting) {
                              var tempCenterMarker = [];
                              tempCenterMarker.push(
                                <div
                                  key={Math.random()}
                                  className="marker-container"
                                  onDoubleClick={() =>
                                    this.setMarker(
                                      updateAddress,
                                      updateLocation,
                                      apiKey,
                                      updateMarkers,
                                      centerMarker,
                                      updateCenterMarker,
                                      updateName
                                    )
                                  }
                                ></div>
                              );
  
                              updateCenterMarker(tempCenterMarker);
                            }
                            if (isEditting) {
                              let _markers = markers;
                              _markers[addressId] = [location.lng, lat];
                              updateMarkers(_markers);
                            }
                            updateCenterCoordinate({
                              lat: lat,
                              lng: location.lng
                            });
                          }).bind(null, e.target.value),
                          500
                        )
                      );
                    }
                  }}
                />
              </div>
              <div className="address-input">
                <label>نشانی</label>
                <div className="close-wrapper">
                  <Input
                    required
                    primary
                    onInvalid={e => {
                      InvalidMsg(
                        e.target,
                        "لطفا نشانی را وارد نمایید(یا مقصد را روی نقشه تایید نمایید)",
                        "نشانی می تواند ترکیبی از عدد و حروف باشد.",
                        setMessage
                      );
                    }}
                    value={address}
                    placeholder="نشانی"
                    onInput={e => updateAddress(e.target.value)}
                  />
                  <div
                    className="close-icon"
                    onClick={() =>
                      deleteInputs(
                        address,
                        updateAddress,
                        updateLocation,
                        markers,
                        updateMarkers,
                        updateName,
                        setTime
                      )
                    }
                  ></div>
                </div>
              </div>
              <div className="address-name">
                <label>نام مقصد</label>
                <Input
                  required
                  onInvalid={e => {
                    InvalidMsg(
                      e.target,
                      "لطفا نام مقصد را وارد نمایید",
                      "نام مقصد می تواند ترکیبی از عدد و حروف باشد.",
                      setMessage
                    );
                  }}
                  primary
                  className="destination-name"
                  value={name}
                  placeholder="نام مقصد"
                  onInput={e => updateName(e.target.value)}
                />
              </div>
              {demo === "Vrp" ? (
                <div className="time-window">
                  <label>زمان توقف</label>
                  <Input
                    required
                    onInvalid={e => {
                      InvalidMsg(
                        e.target,
                        "لطفا زمان توقف را وارد نمایید",
                        "لطفا از فرمت ۰۰:۰۰:۰۰ استفاده نمایید",
                        setMessage
                      );
                    }}
                    primary
                    value={time}
                    placeholder="00:00"
                    onInput={e => setTime(window.toEnglishDigits(e.target.value))}
                  />
                </div>
              ) : (
                ""
              )}

              <div className="submit">
                <Button
                  softDisabled={!name.length || !address.length}
                  tertiary={isEditting}
                  onClick={e =>
                    submitAddress(
                      e,
                      updateAddress,
                      destinations,
                      updateDestinations,
                      location,
                      updateLocation,
                      updateName,
                      name,
                      addressId,
                      updateAddressId,
                      time,
                      setTime,
                      setMessage
                    )
                  }
                >
                  ثبت
                </Button>
              </div>
            </form>
          </div>
        );
      }}
    </MapDemoContext.Consumer>
  );
}

export default AddressBar;
